import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { formValueSelector } from 'redux-form';

import { LOG_IN_FORM } from '../../constants';

import {
    clearAuthNotification as clearAuthNotificationAction,
    redirectToLogIn as redirectToLogInAction,
    signUpUser as signUpUserAction,
    cleanSocialAuthenticationData as cleanSocialAuthenticationDataAction,
    resetForm as resetFormAction,
} from '../../actions/auth';

import {
    trackConfirmEmailShowed as trackEmailConfirmationAction,
    trackEditEmailMismatch as trackEmailMismatchAction,
} from '../../actions/gaTracking';

import {
    cancelToS as cancelToSAction,
    acceptToS as acceptToSAction,
    acceptSocialToS as acceptSocialToSAction,
    showToS as showToSAction,
} from '../../actions/tos';

import {
    lookupUser as lookupUserAction,
    setSignupSecondStep as setSignupSecondStepAction,
} from '../../actions/lookup';

import { loadGoogleOneTap as loadGoogleOneTapAction } from '../../actions/social';

import { sendSoftAccountEmail as sendSoftAccountEmailAction } from '../../actions/softAccount';

import SignupPage from './SignupPage';

const _mapStateToProps = (state) => ({
    form: state.form,
    email: state.authentication.email,
    locale: state.authentication.locale,
    recaptcha2PublicKey: state.authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: state.authentication.recaptcha3PublicKey,
    showCaptcha: state.authentication.displayCaptcha,
    fp: state.authentication.fp,
    socialSSOSettings: state.social.socialSSOSettings,
    authNotificationOptions: state.authentication.authNotificationOptions,
    disableRecaptcha3: state.authentication.disableRecaptcha3,
    launchAsyncStrategyForAuthSocialScripts:
        state.authentication.featureFlags
            .launchAsyncStrategyForAuthSocialScripts,
    signUpSecondStep: state.status.signUpSecondStep,
    previousFormEmail: formValueSelector(LOG_IN_FORM)(state, 'email'),
    isSoftAccount: state.frontend.showModal,
    launchGoogleOneTapWeb:
        state.authentication.featureFlags.launchGoogleOneTapWeb,
});

const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onLoginInsteadClick: redirectToLogInAction,
    onSignupLookup: lookupUserAction,
    onSignUpUser: signUpUserAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    setSignupSecondStep: setSignupSecondStepAction,
    cancelToS: cancelToSAction,
    acceptToS: acceptToSAction,
    acceptSocialToS: acceptSocialToSAction,
    showToS: showToSAction,
    cleanSocialAuthenticationData: cleanSocialAuthenticationDataAction,
    handleSoftAccount: sendSoftAccountEmailAction,
    resetForm: resetFormAction,
    loadGoogleOneTap: loadGoogleOneTapAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignupPage),
);
